import { render, staticRenderFns } from "./GrantBankAccountDialog.vue?vue&type=template&id=db0b7dea&scoped=true"
import script from "./GrantBankAccountDialog.vue?vue&type=script&lang=js"
export * from "./GrantBankAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./GrantBankAccountDialog.vue?vue&type=style&index=0&id=db0b7dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b7dea",
  null
  
)

export default component.exports